import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div style={{
        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{label}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ margin: '5px 0', color: entry.color }}>
            {entry.name}: {entry.value}{!data.hasCompleteData && '*'}
          </p>
        ))}
        {!data.hasCompleteData && (
          <p style={{ margin: '5px 0', fontSize: '0.85em', color: '#666', fontStyle: 'italic' }}>
            * Kun premierte
          </p>
        )}
      </div>
    );
  }
  return null;
};

export const ParticipantChart = ({ data }) => {
  const [hiddenLines, setHiddenLines] = React.useState({});

  // Create a map to store yearly aggregate data
  const yearlyAggregates = new Map();
  data.forEach(item => {
    if (item.part === 'Hele året') {
      yearlyAggregates.set(item.year, {
        participantCount: item.participantCount,
        submissionCount: item.submissionCount
      });
    }
  });

  // Transform data and add yearly aggregate values to Vår and Høst entries
  const chartData = data
    .filter(item => item.part !== 'Hele året') // Remove "Hele året" entries from X-axis
    .map(item => {
      const yearlyData = yearlyAggregates.get(item.year);
      return {
        name: item.part ? `${item.year} ${item.part}` : `${item.year}`,
        year: item.year,
        deltakere: item.participantCount,
        innleveringer: item.submissionCount,
        deltakereHelAr: yearlyData ? yearlyData.participantCount : null,
        innleveringerHelAr: yearlyData ? yearlyData.submissionCount : null,
        hasCompleteData: item.hasCompleteData,
        isYearlyAggregate: false
      };
    });

  const handleLegendClick = (e) => {
    setHiddenLines(prev => ({
      ...prev,
      [e.dataKey]: !prev[e.dataKey]
    }));
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={chartData}
        margin={{
          top: 5,
          right: 60,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          angle={-45}
          textAnchor="end"
          height={100}
          style={{ fontSize: '12px' }}
        />
        <YAxis
          yAxisId="left"
          stroke="#90b361"
          label={{ value: 'Deltakere', angle: -90, position: 'insideLeft', style: { fill: '#90b361' } }}
          tick={{ fill: '#90b361' }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          stroke="#36501c"
          label={{ value: 'Innleveringer', angle: 90, position: 'insideRight', style: { fill: '#36501c' } }}
          tick={{ fill: '#36501c' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          onClick={handleLegendClick}
          wrapperStyle={{ cursor: 'pointer', paddingTop: '10px' }}
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="deltakere"
          stroke="#90b361"
          strokeWidth={2}
          activeDot={{ r: 8 }}
          name="Deltakere"
          hide={hiddenLines.deltakere}
          connectNulls={false}
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="deltakereHelAr"
          stroke="#6b8a47"
          strokeWidth={3}
          strokeDasharray="5 5"
          activeDot={{ r: 8 }}
          name="Deltakere (Hele året)"
          hide={hiddenLines.deltakereHelAr}
          connectNulls={true}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="innleveringer"
          stroke="#36501c"
          strokeWidth={2}
          activeDot={{ r: 8 }}
          name="Innleveringer"
          hide={hiddenLines.innleveringer}
          connectNulls={false}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="innleveringerHelAr"
          stroke="#1e2e0f"
          strokeWidth={3}
          strokeDasharray="5 5"
          activeDot={{ r: 8 }}
          name="Innleveringer (Hele året)"
          hide={hiddenLines.innleveringerHelAr}
          connectNulls={true}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
